<template>
    <div class="mobile_c">
        <van-nav-bar title="历史数据" placeholder fixed>
            <template #left>
                <van-icon @click="goindex" name="wap-home-o" size="22" color="#000" />
            </template>
        </van-nav-bar>

        <div class="tim_userlist">
            <div class="itmes" v-for="(item, index) in nowFriendList" :key="index" @click="getUserInfo(item)">
                <div class="items_img">
                    <img :src="item.user_info
                        .avatar" alt="" srcset="">
                </div>
                <div class="items_cont">
                    <div class="items_top">
                        <div class="items_name">{{ item.user_info.nickname }}</div>
                    </div>
                </div>
            </div>
            <div class="kongts" v-if="nowFriendList.length == ''">
                <div>
                    <img src="@/assets/tim/leftkong.png" alt="" srcset="">
                    <div class="texts">
                        暂无联系人
                    </div>
                </div>
            </div>
        </div>
        <Tabbar :uactive="3"></Tabbar>
    </div>
</template>

<script>
import Tabbar from '@/components/TimMobile/tabbar.vue';
import { sessionList } from '@/api/txim'
export default {
    components: {
        Tabbar
    },
    name: '',
    data() {
        return {
            nowFriendList: []
        }
    },
    mounted() {
        sessionList().then(res => {
            if (res.code == 1) {
                this.nowFriendList = res.data.list
            }
        })
    },
    methods: {
        goindex() {
            this.$router.push({ path: "/" }).catch(() => { });
        },
        getUserInfo(item){
            this.$router.push({ path: "/lssj" ,query:item}).catch(() => { });
            
        }
    },
}
</script>
<style lang='scss' scoped>
.mobile_c {
    width: 100%;
}
.kongts {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 700px;
    text-align: center;

    img {
        width: 42px;
        height: 42px;
    }

    .texts {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #ADAAAA;
        line-height: 46px;
    }

}
.tim_userlist {
    width:100%;
    .itmes {
        display: flex;
        margin: 14px 10px;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 10px;
        align-items: center;

        .items_img {
            width: 40px;
            height: 40px;
            border-radius: 10px;

            img {
                width: 40px;
                height: 40px;
                border-radius: 10px;
            }
        }

        .items_cont {
            flex: 1;
            margin-left: 9.2px;
        }

        .items_top {
            display: flex;
            justify-content: space-between;
            align-content: center;

            .items_name {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 14px;
                color: #000000;
            }

            .items_time {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #ADAAAA;
            }


        }

        .items_text {
            width: 140px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #ADAAAA;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .itmes:active {
        background: #f4f4f4 !important;
    }
}
</style>